import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useEffect, useRef } from 'react';
import { usePrevious } from '../../utils/usePrevious';
import { useStateInRef } from '../../utils/useStateInRef';
import { useOverlayContext } from '../OverlayContext';
/** Renders a modal whose open state is controlled by props.  */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
export function DeclarativeModal(props) {
    const { isOpen } = props;
    const globalContext = useOverlayContext();
    const prevIsOpen = usePrevious(isOpen);
    const getProps = useStateInRef(_object_spread_props(_object_spread({}, props), {
        prevIsOpen
    }));
    const dismissModalRef = useRef(()=>{});
    useEffect(()=>{
        const _getProps = getProps(), { isOpen, prevIsOpen, content, onClose } = _getProps, rest = _object_without_properties(_getProps, [
            "isOpen",
            "prevIsOpen",
            "content",
            "onClose"
        ]);
        if (isOpen && !prevIsOpen) {
            let wasClosed = false;
            globalContext.showModal(_object_spread_props(_object_spread({}, rest), {
                biName: props.biName,
                biData: props.biData,
                content: (p)=>{
                    dismissModalRef.current = function() {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                            args[_key] = arguments[_key];
                        }
                        return p.dismissModal(...args);
                    };
                    return content(_object_spread_props(_object_spread({}, p), {
                        dismissModal: dismissModalRef.current
                    }));
                }
            })).then(()=>{
                if (wasClosed) return;
                wasClosed = true;
                dismissModalRef.current = ()=>{};
                onClose && onClose();
            });
        }
        if (prevIsOpen && !isOpen) {
            dismissModalRef.current();
        }
    }, [
        isOpen
    ]);
    useEffect(()=>{
        return ()=>{
            dismissModalRef.current();
        };
    }, []);
    return null;
}
